import React, { useEffect, useState } from 'react';
import { Tag } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import InnerHeader from '../../component/InnerHeader';
import NoxTable from '../../component/Table';
import { getAllClaims, removeClaimAction, downloadClaimCsvAction } from '../../actions/claimAction';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';
// import sortClaims from '../../helpers/sortClaims';
import camelCaseToTitleCase from '../../helpers/camelCaseToTitleCase';

const Claims = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  const urlLocation = useLocation();
  const currentProject = useSelector(({ project }) => project.currentProject);
  // const warningDate = useSelector(({ claims }) => claims.warningDate);

  const filterList = [
    'All',
    'Assigned to Lawyer',
    'Assigned to Manager',
    'In Progress',
    'In Review',
    'Accepted by Airline',
    'Approved',
    'Compensation paid',
    'Paid to PAX',
    'Commission Received',
    'Paid by Airline',
    'Sent to Airline ',
    'Appealed in ADR',
    'Appealed in Court',
    'Rejected by Airline  ',
    'Returned to Manager',
    'Declined',
    'Customer Unavailable',
    'Lack of Information',
    'Pending'
  ];

  const red = [
    'rejectedByAirline',
    'returnedToManager',
    'declined',
    'customerUnavailable',
    'lackOfInformation',
    'pending'
  ];

  const green = [
    'acceptedByAirline',
    'approved',
    'compensationPaid',
    'paidToPAX',
    'commissionReceived',
    'paidByAirline'
  ];

  const gray = ['inProgress', 'inReview', 'assignedToLawyer', 'assignedToManager'];

  const yellow = ['sentToAirline', 'appealedInADR', 'appealedInCourt'];

  const onFilterChange = (value) => {
    const params = qs.parse(urlLocation.search, { ignoreQueryPrefix: true });
    params.filter = [value.toLowerCase().split(' ').join('')];

    history.push({
      pathname: `/claims`,
      search: qs.stringify(params)
    });
  };

  const getContentFromProblems = (problems = []) => {
    if (!problems.length) {
      return '';
    }

    const stringifiedProblems = problems.toString().replace(/,/g, ', ');

    return stringifiedProblems.replace('reimbursementCostOfTheTicket', 'Overbooking');
  };

  const mapToTable = (claims) => {
    const data = [];

    if (!claims || claims.length === 0) {
      return data;
    }

    claims.forEach(
      (
        {
          _id,
          problems,
          email,
          claimStatus,
          createdAt,
          created,
          phoneNumber,
          phoneCode,
          departureAirport,
          arrivalAirport,
          token,
          submittedAt,
          firstName,
          lastName,
          lawyerFullName,
          airlineName,
          ticketDepartureDate
        },
        index
      ) => {
        const finalDate = formatDate(createdAt || created);
        const content = getContentFromProblems(problems);
        const phone = phoneCode + phoneNumber;
        const places = `${departureAirport?.name} - ${arrivalAirport?.name}`;

        data.push({
          _id,
          airline: airlineName || '',
          claimStatus,
          content,
          created: finalDate,
          email,
          flightDate: ticketDepartureDate ? formatDate(ticketDepartureDate) : '',
          key: index,
          lawyerFullName: lawyerFullName || '',
          passenger: `${firstName || ''}  ${lastName || ''}`,
          phone,
          places,
          submission: submittedAt ? formatDate(submittedAt) : '',
          token
        });
      }
    );

    return data;
  };

  useEffect(() => {
    async function load() {
      dispatch(getAllClaims());
    }

    if (currentProject) {
      load();
    }
  }, [dispatch, currentProject]);

  const filterData = (data) => {
    const selectedFilter = getInitialFilterFromUrl();
    if (selectedFilter[0] === 'All') {
      return data;
    }
    if (selectedFilter[0] === 'all') {
      return data;
    }

    return data.filter((item) => item.claimStatus.toLowerCase() === selectedFilter[0]);
  };

  const getInitialFilterFromUrl = () => {
    const { filter } = qs.parse(urlLocation.search, {
      ignoreQueryPrefix: true
    });

    return filter || [filterList[0]];
  };

  const onDownloadCsv = () => {
    dispatch(downloadClaimCsvAction());
  };

  const onClaimDelete = async () => {
    await Promise.all(
      selectedRowKeys.map(async (index) => {
        const item = data[index];

        dispatch(removeClaimAction(item._id));
      })
    );
    dispatch(getAllClaims());
    setSelectedRowKeys([]);
  };

  const isLoaded = useSelector(({ claims }) => claims.isLoaded);
  const claims = useSelector(({ claims }) => claims.claims);
  const data = mapToTable(claims);
  const filteredData = filterData(data);

  const columns = [
    {
      dataIndex: '_id',
      key: '_id',
      render: (_id) => {
        return <Copy text={_id} />;
      },
      sorter: (a, b) => a._id.localeCompare(b._id),
      title: 'ID'
    },
    {
      dataIndex: 'created',
      key: 'created',
      render: (created) => {
        return <Copy text={created} />;
      },
      sorter: (a, b) => new Date(a.created) - new Date(b.created),
      title: 'Created'
    },
    {
      dataIndex: 'submission',
      key: 'submission',
      render: (submission) => {
        return <Copy style={{ width: '100%' }} text={submission} />;
      },
      sorter: (a, b) => new Date(!b.submission) - new Date(a.submission),
      title: <div>Date Of Submission</div>
    },
    {
      dataIndex: 'content',
      key: 'content',
      render: (content) => {
        return <Copy text={camelCaseToTitleCase(content)} />;
      },
      sorter: (a, b) => a.content.localeCompare(b.content),
      title: 'Content'
    },
    {
      dataIndex: 'airline',
      key: 'airline',
      render: (airline) => {
        return <Copy text={airline} />;
      },
      sorter: (a, b) => a.airline.localeCompare(b.airline),
      title: 'Airline'
    },
    {
      dataIndex: 'passenger',
      key: 'passenger',
      render: (passenger) => {
        return <Copy text={passenger} />;
      },
      sorter: (a, b) => a.passenger.localeCompare(b.passenger),
      title: 'Passenger'
    },
    {
      dataIndex: 'lawyerFullName',
      key: 'lawyerFullName',
      render: (lawyerFullName) => {
        return <Copy text={lawyerFullName} />;
      },
      sorter: (a, b) => a.lawyerFullName.localeCompare(b.lawyerFullName),
      title: 'Lawyer'
    },
    {
      dataIndex: 'email',
      key: 'email',
      render: (email) => {
        return <Copy text={email} />;
      },
      sorter: (a, b) => a.email.toString().localeCompare(b.email),
      title: <div>Email (Passenger)</div>
    },
    {
      dataIndex: 'phone',
      key: 'phone',
      render: (phone) => {
        return <Copy text={phone} />;
      },
      sorter: (a, b) => a.phone.localeCompare(b.phone),
      title: 'Phone (Passenger)'
    },
    {
      dataIndex: 'places',
      key: 'places',
      render: (places) => {
        return <Copy style={{ width: '100%' }} text={places} />;
      },
      sorter: (a, b) => a.places.localeCompare(b.places),
      title: <div>Arrival and Departure</div>
    },
    {
      dataIndex: 'flightDate',
      key: 'flightDate',
      render: (flightDate) => {
        return <Copy style={{ width: '100%' }} text={flightDate} />;
      },
      sorter: (a, b) => new Date(a.flightDate) - new Date(b.flightDate),
      title: <div>Flight Date</div>
    },
    {
      dataIndex: 'claimStatus',
      key: 'claimStatus',
      render: (claimStatus) => {
        let style = {};

        if (gray.includes(claimStatus)) {
          style = {
            backgroundColor: 'rgba(65, 204, 156, 0.15)',
            color: '#41CC9C'
          };
        }

        if (yellow.includes(claimStatus)) {
          style = {
            backgroundColor: 'rgba(155, 160, 173, 0.15)',
            color: '#9BA0AD'
          };
        }

        if (red.includes(claimStatus)) {
          style = {
            backgroundColor: 'rgba(255, 71, 108, 0.15)',
            color: '#FF476C'
          };
        }

        if (green.includes(claimStatus)) {
          style = {
            backgroundColor: 'rgba(244, 211, 37, 0.15)',
            color: '#F4CD00'
          };
        }

        return (
          <Tag
            key={claimStatus}
            style={{
              ...style,
              border: 'none',
              cursor: 'default',
              width: '90%'
            }}
          >
            {camelCaseToTitleCase(claimStatus)}
          </Tag>
        );
      },
      sorter: (a, b) => a.claimStatus.localeCompare(b.claimStatus),
      title: <div>Status</div>
    },
    {
      key: 'edit',
      render: (data) => {
        return <Link to={`/claims/${data.token}`}>edit</Link>;
      }
    }
  ];
  // <Tag
  //   onClick={() => {
  //     history.push(`/claims/${data.token}`);
  //   }}
  // >
  //   edit
  // </Tag>;

  const actions = [
    {
      onClick: onDownloadCsv,
      title: 'Download .CSV',
      type: 'primary'
    }
  ];

  if (selectedRowKeys.length) {
    actions.unshift({
      onClick: onClaimDelete,
      title: 'Delete',
      type: 'secondaryModified'
    });
  }

  return (
    <div
      style={{
        backgroundColor: 'white',
        height: 'calc(100vh - 155px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={claims?.length} title="Claims" />
      <NoxTable
        actions={actions}
        claim
        columns={columns}
        data={filteredData}
        filterList={[filterList]}
        loading={!isLoaded}
        onFilterChange={onFilterChange}
        searchBy="email"
        selectedFilter={getInitialFilterFromUrl()}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default Claims;
